module.exports = __webpack_public_path__ + "static/ms-icon-144x144-a40224513f30b3d55deb8c903f4672ee.png";